import { render } from "./XIconSolidHandCoins.vue?vue&type=template&id=3e3280c6"
import script from "./XIconSolidHandCoins.vue?vue&type=script&lang=js"
export * from "./XIconSolidHandCoins.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidHandCoins.vue"]])

export default __exports__